// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__D_PbS","row":"Node_row__ytEsB","label":"Node_label__3PHFC","footer":"Node_footer__35_jx"};